<template>
    <div class="overlay">
        <form class="container" @submit.prevent="submitForm">
            <h3>
                {{ $t("rgpd.popinTitle") }}
            </h3>
            <div class="list-container">
                <CheckBox
                    :backgroundColor="checkboxBgColor"
                    :foregroundColor="checkboxFgColor"
                    :text="$t('rgpd.termsAndConditionsText')"
                    :value="termsAndConditionsConsent"
                    @input="
                        event => {
                            termsAndConditionsConsent = event;
                        }
                    "
                />
                <div v-if="error.length" class="error">{{ error }}</div>
                <CheckBox
                    v-if="emailConsent"
                    :backgroundColor="checkboxBgColor"
                    :foregroundColor="checkboxFgColor"
                    :text="$t('rgpd.shareEmailText')"
                    :value="shareEmailConsent"
                    @input="newValue => (shareEmailConsent = newValue)"
                />
            </div>
            <div class="popin-footer">
                <button v-if="emailConsent" class="fill" @click.prevent="acceptAll">
                    {{ $t("rgpd.acceptAll") }}
                </button>
                <button type="submit">{{ $t("rgpd.submit") }}</button>
                <a v-if="emailConsent" href="#" @click.prevent="rejectAll">{{
                    $t("rgpd.rejectAll")
                }}</a>
            </div>
        </form>
    </div>
</template>
<script lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import CheckBox from "@/components/Checkbox.vue";

export default {
    name: "RGPDPopin",
    components: {
        CheckBox: CheckBox
    },
    emits: ["close"],
    props: {
        emailConsent: {
            type: Boolean,
            default: true
        }
    },
    setup(props, { emit }) {
        const { t } = useI18n({ useScope: "global" });
        const shareEmailConsent = ref(false);
        const termsAndConditionsConsent = ref(false);
        const checkboxBgColor = ref("#D2D2D2");
        const checkboxFgColor = ref("#000000");

        const error = ref("");

        async function submitForm() {
            if (!termsAndConditionsConsent.value) {
                error.value = t("rgpd.error.termsAndConditionsCheckboxRequired");
            } else {
                error.value = "";

                try {
                    emit("close", {
                        termsAndConditionsConsent: termsAndConditionsConsent.value,
                        shareEmailConsent: props.emailConsent ? shareEmailConsent.value : undefined
                    });
                } catch {
                    error.value = "An error occured";
                }
            }
        }

        function acceptAll() {
            termsAndConditionsConsent.value = true;
            shareEmailConsent.value = true;
        }

        function rejectAll() {
            termsAndConditionsConsent.value = false;
            shareEmailConsent.value = false;

            submitForm();
        }

        return {
            submitForm,
            acceptAll,
            rejectAll,
            shareEmailConsent,
            termsAndConditionsConsent,
            error,
            checkboxBgColor,
            checkboxFgColor
        };
    }
};
</script>
<style scoped>
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(1, 1, 1, 0.5);
    transition-duration: 0.5s;
    z-index: 10;
}

.container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid var(--secondary);
    padding: 20px;
    display: flex;
    flex-direction: column;
    background: var(--white);
    z-index: 10;
}

.container h3 {
    font-size: 1.35em;
    margin-top: 0;
    text-align: left;
}

.popin-footer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 25px;
    align-items: center;
    margin-top: 20px;
}

.popin-footer button {
    border: 2px solid var(--black);
    background: var(--white);
    color: var(--black);
    border-radius: 3px;
    font-size: 1.2em;
    flex-grow: 1;
    padding-top: 7px;
    padding-bottom: 7px;
}

.popin-footer button.fill {
    background: var(--black);
    color: var(--white);
}

.popin-footer a {
    color: var(--black);
    text-align: center;
    grid-column: 1/3;
}

.error {
    color: var(--red);
    text-align: center;
}
</style>
<style>
.list-item-text a {
    color: var(--black);
    text-decoration: underline;
}
</style>
